export default __webpack_public_path__ + "static/media/cover.2513fbe8.jpg";